import React from 'react';
import axios from 'axios';

/**
 * Interceptor para tratar respostas problemáticas do backend
 * Converte respostas com status 200 mas com erro em status 401
 */
export const setupApiInterceptor = () => {
  // Interceptor de resposta
  axios.interceptors.response.use(
    (response) => {
      // Log apenas para rotas específicas ou em caso de erro
      if (response.config.url?.includes('/signin') || response.status !== 200) {
        console.log('🔍 Interceptor - URL:', response.config.url);
        console.log('🔍 Interceptor - Status:', response.status);
        console.log('🔍 Interceptor - Data:', response.data);
      }

      // Verificar se é uma resposta de login com erro
      if (response.config.url?.includes('/signin') && response.data) {
        // Se o token não é uma string válida, tratar como erro
        if (response.data.token && typeof response.data.token !== 'string') {
          console.log('❌ Interceptor - Convertendo resposta de login para erro 401');
          // Criar um erro artificial com status 401
          const error = new Error('Authentication failed');
          error.response = {
            status: 401,
            data: {
              message: response.data.token.message || 'Credenciais inválidas'
            }
          };
          return Promise.reject(error);
        }
      }

      // Não interferir em outras rotas, especialmente verifyToken
      return response;
    },
    (error) => {
      console.log('💥 Interceptor - Erro capturado:', error.response?.status, error.response?.data);
      // Passar o erro adiante sem modificação
      return Promise.reject(error);
    }
  );
};

/**
 * Hook para configurar o interceptor
 */
export const useApiInterceptor = () => {
  React.useEffect(() => {
    setupApiInterceptor();
  }, []);
};
